export const FORMULA_EMPTY = "FORMULA_EMPTY";
export const FORMULA_GRAMMAR_INVALID = "FORMULA_GRAMMAR_INVALID";
export const FORMULA_UNKNOWN_VARIABLE = "FORMULA_UNKNOWN_VARIABLE";
